import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';

import { FuseSearchBarModule, FuseShortcutsModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

import { ToolbarComponent } from 'app/layout/components/toolbar/toolbar.component';
import { UserFacade } from 'app/main/user/user.facade';
import { User } from 'app/main/user/user.model';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { UserService } from 'app/main/user/user.service';
import { AuthStoreModule } from 'app/main/auth/store/store.module';
import { authReducer } from 'app/main/auth/store/auth.reducer';
import { AuthEffects } from 'app/main/auth/store/auth.effects';
import { TranslateModule } from '@ngx-translate/core';
import { NOTIFICATION, notificationReducer } from 'app/shared/notifications/notification.state';
import { NotificationEffects } from 'app/shared/notifications/notification.effects';
import { NotificationFacade } from 'app/shared/notifications/notification.facade';
import { NotificationService } from 'app/shared/notifications/notification.service';
import { Notification } from 'app/shared/notifications/notification.model';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { NotificationsComponent } from 'app/shared/notifications/notifications.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NotificationsModule } from 'app/shared/notifications/notifications.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { GroupeFacade } from 'app/main/groupe/groupe.facade';
import { Groupe } from 'app/main/groupe/groupe.model';
import { GroupeService } from 'app/main/groupe/groupe.service';
import { StatutNotificationFacade } from 'app/shared/notifications/statut-notification/statut-notification.facade';
import { StatutNotification } from 'app/shared/notifications/statut-notification/statut-notification.model';
import { StatutNotificationService } from 'app/shared/notifications/statut-notification/statut-notification.service';
import { DEFAULT_DATE_FORMATS } from 'app/shared/utils/default-date-formats';
import { NgrxAutoEntityModule } from '@briebug/ngrx-auto-entity';
import { GROUPE, groupeReducer } from 'app/main/groupe/groupe.state';
import { UserEffects } from 'app/main/user/user.effects';
import { USER, userReducer } from 'app/main/user/user.state';
import { StatutNotificationEffects } from 'app/shared/notifications/statut-notification/statut-notification.effects';
import { STATUTNOTIFICATION, statutNotificationReducer } from 'app/shared/notifications/statut-notification/statut-notification.state';
import { ParameterSearchModule } from 'app/shared/parameter-search/parameter-search.module';

@NgModule({
    declarations: [
        ToolbarComponent,
        // NotificationsComponent
    ],
    imports     : [
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatToolbarModule,

        TranslateModule,
        ConfirmDialogModule,
        FuseSharedModule,
        FuseSearchBarModule,
        FuseShortcutsModule,
        ParameterSearchModule,

        // OverlayModule,
        // PortalModule,
        // MatTooltipModule,

        NotificationsModule,
        
        AuthStoreModule,
        StoreModule.forFeature('auth',authReducer),
        StoreModule.forFeature(NOTIFICATION, notificationReducer),

        EffectsModule.forFeature([NotificationEffects]),
        EffectsModule.forRoot([AuthEffects]),


        StoreModule.forFeature(GROUPE, groupeReducer),
        StoreModule.forFeature(USER, userReducer),
        StoreModule.forFeature(STATUTNOTIFICATION, statutNotificationReducer),
  
  
        EffectsModule.forFeature([UserEffects,StatutNotificationEffects]),
        NgrxAutoEntityModule.forFeature()
    ],
    providers: [
       
        { provide: Notification, useClass: NotificationService },
        NotificationFacade,
        NotificationService,

        { provide: StatutNotification, useClass: StatutNotificationService },
        StatutNotificationService,
        StatutNotificationFacade,
        { provide: Groupe, useClass: GroupeService },
        GroupeService,
        GroupeFacade , 
  
        { provide: User, useClass: UserService },
        UserFacade,
        UserService,
        { provide: MAT_DATE_FORMATS, useValue: DEFAULT_DATE_FORMATS }
    ],
    exports     : [
        ToolbarComponent,
        // NotificationsComponent
    ]
})
export class ToolbarModule
{
}
